import { render, staticRenderFns } from "./dietarySuggestion.vue?vue&type=template&id=3c321592&scoped=true&"
import script from "./dietarySuggestion.vue?vue&type=script&lang=js&"
export * from "./dietarySuggestion.vue?vue&type=script&lang=js&"
import style0 from "./dietarySuggestion.vue?vue&type=style&index=0&id=3c321592&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c321592",
  null
  
)

export default component.exports